import { render, staticRenderFns } from "./statistic_platform_user.vue?vue&type=template&id=b0cdca46&scoped=true"
import script from "./statistic_platform_user.vue?vue&type=script&lang=js"
export * from "./statistic_platform_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cdca46",
  null
  
)

export default component.exports